export const LEGEND_OPACITY = {
    ENABLED: 1,
    DISABLED: 0.5,
};
